module.exports = __webpack_public_path__ + "img/loader.deea79a0.svg";